import { render, staticRenderFns } from "./genericSubClassifierView.vue?vue&type=template&id=21c1e25f&scoped=true&"
import script from "./genericSubClassifierView.vue?vue&type=script&lang=js&"
export * from "./genericSubClassifierView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21c1e25f",
  null
  
)

export default component.exports